import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RoutesConstants, StorageConstants } from '../../../shared/constants';
import { NavigatorHelper, StorageHelper } from '../../../shared/helpers';
import { ApiService } from '../../../shared/services/api.service';
import { AppTypeEnum } from '../../../shared/enums';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../../../shared/dialogs/info-dialog/info-dialog.component';
import { StockingService } from '../../../shared/services/stocking.service';

@Component({
  selector: 'app-stocking-home',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './stocking-home.component.html',
  styleUrl: './stocking-home.component.scss'
})
export class StockingHomeComponent {
  public dynId = StockingService.dynId();

  constructor(
    private router: Router,
    private dialog: MatDialog,
  ) {
    if (!this.dynId) {
      this.dynId = StorageHelper.getItem<string>(StorageConstants.DYN_ID);
    }
    if (this.dynId) {
      StockingService.dynId.set(null);
      StorageHelper.removeItem(StorageConstants.DYN_ID);
    }
  }


  public startApp() {
    StockingService.dynId.set(null);
    StorageHelper.removeItem(StorageConstants.DYN_ID)
    NavigatorHelper.setAppType(AppTypeEnum.stocking);
    this.router.navigate([RoutesConstants.STOCKING_CHANGE_SYSTEM]);
  }

  public openInfo() {
    this.dialog.open(InfoDialogComponent, {
      data: { appType: AppTypeEnum.stocking },
      panelClass: 'info-dialog',
    });
  }

}
